import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import ContactFormButton from '@/components/common/ContactFormButton';

const StickyMobileCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed bottom-0 left-0 right-0 z-[80] md:hidden bg-black/80 backdrop-blur-lg border-t border-white/10 px-4 py-3"
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          <ContactFormButton
            className="w-full justify-center"
            size="default"
            ctaName="sticky_mobile_get_started"
            ctaLocation="sticky_mobile_cta"
            offerType="consultation"
            serviceContext="general"
          >
            Get Started
          </ContactFormButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyMobileCTA;
